import $ from 'jquery';
import Util from 'root/module/util';
import View from 'view/base';
import Cache from 'root/cache';
import Svg_Icon from 'root/module/svg_icon';

export default View.extend({
    className: 'survey-preview-container',

    events: {
        'click .prev'                  : 'onPrevious',
        'click .next'                  : 'onNext',
        'click .survey-template'       : 'onOpenTemplate'
    },

    dom_handlers: {
        onPrevious: function(e) {
            e.preventDefault();

            var previousQuestion = this.getPreviousQuestion();
            if (!previousQuestion) {
                return;
            }

            this.trigger('Question:Select', previousQuestion);
            this.selected_question = previousQuestion;
            this.postDataToCanvas('survey/selectQuestion');
        },

        onNext: function(e) {
            e.preventDefault();

            var nextQuestion = this.getNextQuestion();

            if (!nextQuestion) {
                return;
            }

            this.trigger('Question:Select', nextQuestion);
            this.selected_question = nextQuestion;
            this.postDataToCanvas('survey/selectQuestion');
        },

        onOpenTemplate: function(e) {
            this.trigger('Template:Open');
        }
    },

    initialize: function(options) {
        this.survey = options.survey;
        this.mode = options.mode;
        this.selected_question = this.model;
        this.should_disable_position = options.should_disable_position || false;
        this.is_gallery = !!options.is_gallery;

        // Generate a unique id for the iframe
        this.iframe_uid = 'iframe-' + new Date().getTime() + '-' + Math.random().toString(36).substring(2, 11);

        this.listenTo(this, 'Preview:PostMessage', this.postDataToCanvas);
        this.listenTo(this, 'Preview:SelectQuestion', this.onSelectQuestion);
        this.listenTo(this, 'Preview:AdjustCanvas', this.adjustCanvas);

        this.on('remove', () => {
            window.removeEventListener('message', this.onMessage.bind(this), false);
        });

        window.addEventListener('message', this.onMessage.bind(this), false);
    },

    setData: function(options) {
        this.survey = options.survey;
        this.collection = options.collection;
        this.mode = options.mode;

        // set selected question to first question
        var selected_question = this.collection.at(0);
        this.selected_question = selected_question;

        this.render();
    },

    adjustCanvas: function() {
        var canvas = this.$el.find('#canvas');
        var canvas_container = this.$el.find('.survey-canvas-container');

        if (this.survey.get('format') === 'paged') {
            var size = (
                this.survey.get('position') === 'top' || this.survey.get('position') === 'bottom'
            ) ? 'large' : this.survey.get('size');

            canvas.attr('data-size', size);
            canvas_container.attr('data-position', this.should_disable_position ? 'center' : this.survey.get('position'));
        } else {
            canvas.attr('data-size', 'large');
            canvas_container.attr('data-position', 'center');
        }

        this.$el.find('.region-survey-canvas').attr('data-format', this.survey.get('format'));

        var region_canvas = this.$el;

        if (this.survey.get('has_background_colour')) {
            var colors = this.survey.get('background_colour').split(',');
            var bg_colour = colors[0];
            var bg_opacity = colors[1];

            var rgba_colour = Util.hexToRgba(bg_colour, bg_opacity / 100);

            region_canvas.css('background', rgba_colour);
        } else {
            region_canvas.css('background', '');
        }

        if (this.survey.get('has_close_button')) {
            region_canvas.find('.close').show();
        } else {
            region_canvas.find('.close').hide();
        }
    },

    onSelectQuestion: function(question) {
        if (this.selected_question !== question) {
            this.selected_question = question;
        }
    },

    onMessage: function(e) {
        var data = e.data;
        switch (data.message) {
            case 'designer/init':
                this.postDataToCanvas('survey/init',  {uid: this.iframe_uid});
                this.postDataToCanvas('survey/loadAll');
                break;
            case 'general/height':
                if (data.uid !== this.iframe_uid) {
                    return;
                };

                // fix survey code not to post height: 0
                // remove the if statement
                if (data.height) {
                    this.$el.find('#canvas').height(data.height);
                    this.$el.find('.survey-canvas-container').addClass('loaded');
                }
                break;
            case 'designer/selectQuestion':
                if (data.uid !== this.iframe_uid) {
                    return;
                };

                var question = this.collection.findWhere({question_key: data.key});
                // Dont need to tell iframe to select question
                this.trigger('Question:Select', question, false);
                break;
            case 'designer/updateQuestion':
                if (data.uid !== this.iframe_uid) {
                    return;
                };

                var question = this.collection.findWhere({id: data.data.id});

                question.set(data.data);
                break
        }
    },

    getNextQuestion: function() {
        // Sort survey_questions by putting welcome at first, welcome at last and other questions in the middle
        // also sort other questions by question_sort
        var sorted_questions = this.collection.sort().sortBy((model) => {
            var type = model.get('question_type');
            if (type === 'welcome') {
                return 0;
            } else if (type === 'thankyou') {
                return 2;
            } else {
                return 1;
            }
        });

        var current_index = sorted_questions.indexOf(this.selected_question);

        if (current_index === -1) {
            return;
        }

        var next_index = current_index + 1;

        var last_index = (this.mode === 'preview')
            ? sorted_questions.length - 1
            : sorted_questions.length;

        if (next_index >= last_index) {
            return;
        }

        return sorted_questions.at(next_index);
    },

    getPreviousQuestion: function() {
        var sorted_questions = this.collection.sort().sortBy((model) => {
            var type = model.get('question_type');
            if (type === 'welcome') {
                return 0;
            } else if (type === 'thankyou') {
                return 2;
            } else {
                return 1;
            }
        });

        var current_index = sorted_questions.indexOf(this.selected_question);

        if (current_index === -1) {
            return;
        }

        var previous_index = current_index - 1;

        if (previous_index < 0) {
            return;
        }

        return sorted_questions.at(previous_index);
    },

    postDataToCanvas: function(message) {
        var data = null;
        switch(message) {
            case 'survey/init':
                data = {
                    message,
                    data: {
                        uid: this.iframe_uid
                    }
                }
                break;
            case 'survey/loadAll':
                // Send the survey data to the iframe
                data = {
                    message,
                    data: {
                        survey: this.survey.attributes,
                        questions: this.collection.toJSON(),
                        key: this.selected_question?.get('question_key')
                    }
                }

                break;
            case 'survey/selectQuestion':
                data = {
                    message,
                    data: {
                        key: this.selected_question?.get('question_key')
                    }
                }
                break;
            case 'survey/updateSurvey':
                data = {
                    message,
                    data: {
                        survey: this.survey.attributes,
                        questions: this.collection.toJSON()
                    }
                }
                break;
            case 'survey/updateQuestions':
                data = {
                    message,
                    data: {
                        questions: this.collection.toJSON()
                    }
                }
        }

        var iframe = this.$el.find('#canvas').get(0);
        if (iframe && iframe.contentWindow && data) {
            iframe.contentWindow.postMessage(data, Cache.app.configs.survey_host);
        }
    },

    render: function() {
        var survey_host = Cache.app.configs.survey_host;
        var canvas_path = this.mode === 'edit' ? 'edit' : (survey_host.endsWith('/') ? 'edit/p' : '/edit/p');
        var iframe_src = Cache.app.configs.survey_host + canvas_path;

        // load model data
        var content =
        '<div class="region-floating-buttons">' +
            (this.is_gallery ?
            '<button type="button" class="prev nav"><i class="fas fa-chevron-left"></i></button>' +
            '<button type="button" class="next nav"><i class="fas fa-chevron-right"></i></button>' : '') +

            // no template button or the survey is already active
            (this.is_gallery || this.survey.get('first_active_time') > 0 ? '' :
            '<button type="button" class="survey-template tertiary small min">Templates</button>') +
        '</div>' +
        '<div class="region-survey-canvas" data-mode="' + this.mode + '">' +
            '<div class="survey-canvas-margin-box">' +
                '<div class="survey-canvas-container">' +
                    '<button class="close">' + Svg_Icon.close + '</button>' +
                    '<iframe class="survey-preview-iframe" id="canvas" src="' + iframe_src + '"></iframe>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.$el.attr('data-device', this.preview_device);

        this.adjustCanvas();

        return this;
    }
});
